// Security utilities for protecting video content
// Disables right-click, text selection, and makes DevTools harder to use

export function initSecurityMeasures() {
  // Disable right-click
  document.addEventListener('contextmenu', (e) => {
    e.preventDefault();
    return false;
  });

  // Disable text selection via keyboard shortcuts
  document.addEventListener('keydown', (e) => {
    // Disable Ctrl+A (select all)
    if (e.ctrlKey && e.key === 'a') {
      e.preventDefault();
      return false;
    }
    // Disable Ctrl+C (copy) - only on non-input elements
    if (e.ctrlKey && e.key === 'c' && !['INPUT', 'TEXTAREA'].includes(e.target.tagName)) {
      e.preventDefault();
      return false;
    }
    // Disable Ctrl+U (view source)
    if (e.ctrlKey && e.key === 'u') {
      e.preventDefault();
      return false;
    }
    // Disable Ctrl+Shift+I (DevTools)
    if (e.ctrlKey && e.shiftKey && e.key === 'I') {
      e.preventDefault();
      return false;
    }
    // Disable Ctrl+Shift+J (Console)
    if (e.ctrlKey && e.shiftKey && e.key === 'J') {
      e.preventDefault();
      return false;
    }
    // Disable Ctrl+Shift+C (Inspect element)
    if (e.ctrlKey && e.shiftKey && e.key === 'C') {
      e.preventDefault();
      return false;
    }
    // Disable F12 (DevTools)
    if (e.key === 'F12') {
      e.preventDefault();
      return false;
    }
  });

  // Detect DevTools open (basic detection)
  let devToolsOpen = false;
  const threshold = 160;
  
  const checkDevTools = () => {
    const widthThreshold = window.outerWidth - window.innerWidth > threshold;
    const heightThreshold = window.outerHeight - window.innerHeight > threshold;
    
    if (widthThreshold || heightThreshold) {
      if (!devToolsOpen) {
        devToolsOpen = true;
        console.clear();
        console.log('%c⚠️ ATENȚIE!', 'color: red; font-size: 40px; font-weight: bold;');
        console.log('%cConținutul acestui site este protejat. Copierea sau distribuirea neautorizată este interzisă.', 'color: orange; font-size: 16px;');
      }
    } else {
      devToolsOpen = false;
    }
  };
  
  setInterval(checkDevTools, 1000);

  // Disable drag and drop of images
  document.addEventListener('dragstart', (e) => {
    if (e.target.tagName === 'IMG') {
      e.preventDefault();
      return false;
    }
  });
}

// CSS styles to inject for security
export const securityStyles = `
  /* Disable text selection globally except for inputs */
  body {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  
  /* Allow selection in form inputs - important for forms to work */
  input, textarea, [contenteditable="true"], input[type="text"], input[type="email"], input[type="password"], input[type="tel"] {
    -webkit-user-select: text !important;
    -moz-user-select: text !important;
    -ms-user-select: text !important;
    user-select: text !important;
  }
  
  /* Disable image dragging but keep pointer events */
  img {
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    user-drag: none;
  }
`;

export default { initSecurityMeasures, securityStyles };
